import React, { useEffect } from 'react'
import { Button } from 'app/components';
import { useSelector } from 'react-redux';
import useLoginModal from '../login/useLoginModal';

import './style'

const MobileError = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  },[])

  const loginModal = useLoginModal();
  const { userData } = useSelector((state) => state.app);

  const handleClick = () => {
    const phoneNumber = '9025082101';
    const message = "I'm very interested in your ticketing platform and would love to discuss it further.";
    const desktopUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const mobileUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const isMobile = window.innerWidth < 650; // For mobile, width less than 1024px

    const url = isMobile ? mobileUrl : desktopUrl;
    if (!userData?.email) {
          loginModal.onOpen();
      loginModal.callback.current = () => window.open(url, '_blank');
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <div className='error-container flex flex-col items-center justify-center px-6'>
      <div>
         <img src='/assets/images/gif/mobile-error.gif' alt="My Gif" style={{ width: "180px", height: "180px" }} />
      </div>
      <div className='flex flex-col items-center justify-center  gap-3'>
        <h1 className='heading-16'>Sorry ! It's not you, it's us.</h1>
        <p className='text-grey-70 label-16 text-center'>Currently available on desktop only - but don't worry, our mobile version is on its way!</p>
      </div>
       <div className='flex flex-col items-center justify-center mt-12 mb-8'>
        <h1 className='heading-16 text-center'>Want to create an event? Please <br/> use our desktop version.</h1>
      </div>
      <Button className="w-full git-btn"
        type="primary-black"
        onClick={handleClick}
        iconRight={<img
          src="/assets/images/wp.svg"
          alt="whatsapp"/>}>Get in touch</Button>
    </div>
  )
}

export default MobileError;